import { compareTo3ankvs086tmwq as compareTo } from './js/compareTo.mjs';
import {
  _UInt___get_data__impl__f0vqqw2j5mttix8w0l0 as _UInt___get_data__impl__f0vqqw,
  _UInt___init__impl__l7qpdl2xbmh7to8lpd7 as _UInt___init__impl__l7qpdl,
} from './UInt.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  dividelr0uqtdj497z as divide,
  convertToInty04h231mmjoh as convertToInt,
  shiftRightUnsigned1ga7wnvbv2qur as shiftRightUnsigned,
  shiftLeft3tsh2sstjchzn as shiftLeft,
  multiply2k9eolhnz1bjv as multiply,
  subtract2orl8z9upxd9l as subtract,
  add2suhfggl4zvkk as add,
} from './js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  _ULong___get_data__impl__fggpzb2bbucljk081qt as _ULong___get_data__impl__fggpzb,
  _ULong___init__impl__c78o9k4z3cjzifecv6 as _ULong___init__impl__c78o9k,
} from './ULong.mjs';
import { toString28s61jeiy4rb0 as toString } from './text/numberConversions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function uintCompare(v1, v2) {
  return compareTo(v1 ^ -2147483648, v2 ^ -2147483648);
}
function ulongCompare(v1, v2) {
  return compareTo(v1 ^ -9223372036854775808n, v2 ^ -9223372036854775808n);
}
function uintDivide(v1, v2) {
  // Inline function 'kotlin.UInt.toLong' call
  // Inline function 'kotlin.uintToLong' call
  var value = _UInt___get_data__impl__f0vqqw(v1);
  var tmp = fromInt(value) & 4294967295n;
  // Inline function 'kotlin.UInt.toLong' call
  // Inline function 'kotlin.uintToLong' call
  var value_0 = _UInt___get_data__impl__f0vqqw(v2);
  var tmp$ret$2 = fromInt(value_0) & 4294967295n;
  // Inline function 'kotlin.toUInt' call
  var this_0 = divide(tmp, tmp$ret$2);
  return _UInt___init__impl__l7qpdl(convertToInt(this_0));
}
function ulongDivide(v1, v2) {
  // Inline function 'kotlin.ULong.toLong' call
  var dividend = _ULong___get_data__impl__fggpzb(v1);
  // Inline function 'kotlin.ULong.toLong' call
  var divisor = _ULong___get_data__impl__fggpzb(v2);
  if (divisor < 0n) {
    var tmp;
    // Inline function 'kotlin.ULong.compareTo' call
    if (ulongCompare(_ULong___get_data__impl__fggpzb(v1), _ULong___get_data__impl__fggpzb(v2)) < 0) {
      tmp = _ULong___init__impl__c78o9k(0n);
    } else {
      tmp = _ULong___init__impl__c78o9k(1n);
    }
    return tmp;
  }
  if (dividend >= 0n) {
    return _ULong___init__impl__c78o9k(divide(dividend, divisor));
  }
  var quotient = shiftLeft(divide(shiftRightUnsigned(dividend, 1), divisor), 1);
  var rem = subtract(dividend, multiply(quotient, divisor));
  var tmp_0;
  var tmp0 = _ULong___init__impl__c78o9k(rem);
  // Inline function 'kotlin.ULong.compareTo' call
  var other = _ULong___init__impl__c78o9k(divisor);
  if (ulongCompare(_ULong___get_data__impl__fggpzb(tmp0), _ULong___get_data__impl__fggpzb(other)) >= 0) {
    tmp_0 = 1;
  } else {
    tmp_0 = 0;
  }
  // Inline function 'kotlin.Long.plus' call
  var other_0 = tmp_0;
  var tmp$ret$4 = add(quotient, fromInt(other_0));
  return _ULong___init__impl__c78o9k(tmp$ret$4);
}
function ulongToString(value, base) {
  if (value >= 0n)
    return toString(value, base);
  // Inline function 'kotlin.Long.div' call
  var this_0 = shiftRightUnsigned(value, 1);
  var tmp$ret$0 = divide(this_0, fromInt(base));
  var quotient = shiftLeft(tmp$ret$0, 1);
  // Inline function 'kotlin.Long.times' call
  var this_1 = quotient;
  var tmp$ret$1 = multiply(this_1, fromInt(base));
  var rem = subtract(value, tmp$ret$1);
  if (rem >= fromInt(base)) {
    // Inline function 'kotlin.Long.minus' call
    var this_2 = rem;
    rem = subtract(this_2, fromInt(base));
    // Inline function 'kotlin.Long.plus' call
    var this_3 = quotient;
    quotient = add(this_3, fromInt(1));
  }
  return toString(quotient, base) + toString(rem, base);
}
//region block: exports
export {
  uintCompare as uintCompare18k97xs29243i,
  uintDivide as uintDivide3r5nfwgstcow1,
  ulongCompare as ulongCompare29yg6v52hxi4l,
  ulongDivide as ulongDivide3e52ct8hxp5n7,
  ulongToString as ulongToString1zq54ldfaf473,
};
//endregion

//# sourceMappingURL=UnsignedJs.mjs.map
